// Original Color Palette for Praise Devotion App

export const colors = {
  // Primary Colors - Warm Earthy Theme
  primary: '#6C4D2A',      // Kobicha - dark brown primary
  secondary: '#B09569',    // Lion - medium brown secondary
  accent: '#D0B277',       // Ecru - light golden accent
  background: '#EFE5D7',   // Antique white - cream background
  surface: '#FFFFFF',      // Pure white - card surfaces
  
  // Glassmorphism Colors (keeping for glossy effect)
  glass: 'rgba(255, 255, 255, 0.25)',
  glassBorder: 'rgba(255, 255, 255, 0.18)',
  glassShadow: 'rgba(0, 0, 0, 0.1)',
  
  // Text Colors - Original
  text: '#392F22',         // Taupe - dark brown text
  textSecondary: '#6C4D2A', // Kobicha - secondary text
  textLight: '#FFFFFF',    // Light text on dark backgrounds
  
  // Gradient Colors - Original theme
  gradientStart: '#6C4D2A',
  gradientEnd: '#B09569',
  
  // Legacy colors for backward compatibility
  kobicha: '#6C4D2A',
  lion: '#B09569',
  taupe: '#392F22',
  ecru: '#D0B277',
  antiqueWhite: '#EFE5D7',
  
  // Additional colors for components
  green: '#4CAF50',
  blue: '#2196F3',
  orange: '#FF9800',
  yellow: '#FFC107',
  black: '#000000',
  white: '#FFFFFF',
  grey: '#9E9E9E',
};

export default colors; 